<div class="carousel-wrapper">
  <ng-container *ngIf="!showContent">
    <div class="carousel-container">
      <owl-carousel-o [options]="carouselOptions">
        <ng-template carouselSlide *ngFor="let item of carouselItems">
          <div class="item-container">
            <div class="image-container">
              <img [src]="item.image">

            </div>
            <div class="caption-container">
              <h4><strong>{{ item.heading }}</strong></h4>
              <p class="caption-text">{{ item.caption }}</p>
            </div>
          </div>

        </ng-template>

      </owl-carousel-o>

    </div>
    <div class="land-buttons" style="gap:1rem">
      <div class="orange-button" style="border-radius: 15px !important;" (click)="OnAboutPress()">About us</div>
      <button class="green-button" style="border-radius: 15px !important;" type="button"
        (click)="onSignUp()">Signup/Login</button>
      <!-- <button class="green-button" (click)="OnCorporcateClick()">Corporate</button> -->
      <button class="orange-button" style="border-radius: 15px !important;" (click)="OpenScanner(scanPopup)">Scan Your
        Orders</button>



    </div>
    <!-- <div *ngIf="loggeedUser$ | async as loggeedUser" class="profile-container">
        <div class="avatar">
          <img [src]="loggeedUser.picture" [alt]="loggeedUser.name" />
        </div>
        <h2>{{ loggeedUser.name }}</h2>
        <p>{{ loggeedUser.email }}</p>
      </div> -->
    <!-- <div class="container mt-2">
        <p>Have an Account? <a routerLink="">Login</a></p>
      </div> -->
  </ng-container>
  <ng-container *ngIf="showContent">
    <!-- Content to display when Sign Up button is clicked -->
    <div class="scroll-container">
      <div class="container mt-4">
        <!-- Your Sign Up content goes here -->

        <h4 class="signup-heading "><strong>Log In</strong></h4>

      </div>
      <div class="d-flex justify-content-center">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Personal">
            <div mat-tab-content>
              <div class="signup-container">
                <img src="./assets/images/genieImages/signup_personal_img.png" alt="Personal Image" class="tab-image">
              </div>
              <div class="flex flex-auto">
                <form class="flex flex-col flex-auto p-6 pt-10 sm:p-8 sm:pt-10 overflow-y-auto mt-3"
                  [formGroup]="userForm">
                  <div class="form-group mb-0">
                    <label for="validationCustom02" class="mb-1">
                      Mobile Number:</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text">+91</span>
                      </div>
                      <input class="form-control" formControlName="mobileNumber" placeholder="Mobile Number"
                        type="number" />

                    </div>
                    <span class="text-danger font-weight-bold" *ngIf="!isMobileValid">Mobile Number is Invalid</span>
                  </div>
                  <div class="form-group mb-3" *ngIf="isOtpSent && !isNewUser">
                    <label for="" class="mb-1">Enter OTP You Have Received</label>
                    <ng-otp-input #ngOtpInput formControlName="otp" (onInputChange)="onOtpChange($event)" [config]="{ length: 4 ,
                    allowNumbersOnly: true,
                    inputStyles: {
                    'width': '39px',
                    'height': '39px'
                  }}" name="otp"></ng-otp-input>
                    <p class="mb-2" *ngIf="isOtpSent && timeLeft >0">{{timeLeft}} Seconds Left...</p>
                    <span class="mb-1 text-danger font-weight-bold"
                      *ngIf="isOtpSent && !isOtpVerified && isSubmitted">Wrong OTP Entered</span>
                    <a class="cursor-pointer mb-2" *ngIf="timeLeft ==0">Resend OTP</a>
                  </div>

                  <!-- New User code below -->


                  <div class="sign-up-form-genie" *ngIf="isNewUser">
                    <div class="form-group mb-3">
                      <label for="validationCustom02" class="mb-1">
                        Name:</label>
                      <input class="form-control" formControlName="fName" placeholder="Name" type="text" />
                    </div>
                    <div class="form-group mb-2">
                      <label for="validationCustom02" class="mb-1">
                        Email:</label>
                      <input class="form-control" formControlName="email" placeholder="Email Optional" type="text" />
                      <span class="mb-1 text-danger font-weight-bold" *ngIf="!isEmailValid">Invalid Format/Wrong Email
                        Id</span>

                    </div>
                    <div class="form-group mb-3" *ngIf="isOtpSent">
                      <label for="" class="mb-1">Enter OTP You Have Received</label>
                      <ng-otp-input #ngOtpInput formControlName="otp" (onInputChange)="onOtpChange($event)" [config]="{ length: 4 ,
                  allowNumbersOnly: true,
                  inputStyles: {
                  'width': '39px',
                  'height': '39px'
                }}" name="otp"></ng-otp-input>

                      <p class="mb-2" *ngIf="isOtpSent && timeLeft >0">{{timeLeft}} Seconds Left...</p>
                      <span class="mb-1 text-danger font-weight-bold"
                        *ngIf="isOtpSent && !isOtpVerified && isSubmitted">Wrong OTP Entered</span>
                      <a class="cursor-pointer mb-2" *ngIf="timeLeft ==0">Resend OTP</a>

                    </div>

                  </div>
                </form>
                <div class="container mb-2" *ngIf="isNewUser && isOtpSent">
                  <input type="checkbox" [(ngModel)]="isConditionsAccepted" class="form-check">
                  <p class="align-self-center pl-1" style="margin: 0px !important;">By signing up, you are agreeing to
                    our <a class="cursor-pointer">Terms and Conditions</a></p>
                </div>
                <div class="container">
                  <button class="continue" style="border-radius: 15px !important" *ngIf="!isNewUser && !isOtpSent"
                    (click)="verifyMobileNumber()">Next</button>
                  <button class="continue" style="border-radius: 15px !important" *ngIf="!isNewUser && isOtpSent"
                    (click)="verifyOTP()">Login</button>
                  <button class="continue" style="border-radius: 15px !important" *ngIf="isNewUser && !isOtpSent"
                    (click)="getOTP()">Get OTP</button>
                  <button type="submit" class="continue" style="border-radius: 15px !important"
                    *ngIf="isNewUser && isOtpSent" [disabled]="!isConditionsAccepted"
                    (click)="verifyOTP()">Register</button>
                </div>


              </div>

            </div>

          </mat-tab>
          <mat-tab label="Corporate">

            <div mat-tab-content>
              <div class="signup-container">
                <img src="./assets/images/genieImages/signup_corporate_img.png" alt="Corporate Image" class="tab-image">
              </div>
              <div class="form-group mt-3">
                <label for="validationCustom02" class="mb-1">
                  Enter your corporate code:</label>
                <input class="form-control" [(ngModel)]="stallCode" placeholder="Corporate Code" type="text" />
                <span class="mb-1 text-danger font-weight-bold" *ngIf="isStallCodeValid =='invalid'">Invalid Code</span>
              </div>
              <div class="container">
                <button class="continue" style="border-radius: 15px !important"
                  (click)="checkOrganisation()">Continue</button>
              </div>
              <!-- <div class="container">
              <p>Have an Account? <a routerLink="">Login</a></p>
            </div> -->
            </div>

          </mat-tab>

        </mat-tab-group>

      </div>

    </div>
  </ng-container>
</div>
<ng-template #scanPopup>
  <div class="modal-header">
    <h5 class="modal-title f-w-600" id="exampleModalLabel">Scan</h5>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="scanner-container absolute inset-0 flex flex-col min-w-0 overflow-hidden">

      <qr-scanner #qrscanner (capturedQr)="capturedQr($event)" [texts]="{
                NotSupportedHTML: 'You are using an outdated browser',
                DeviceDefaultPrefix: 'Camera',
                StopCameraText: 'Stop Camera',
                OpenButtonText: 'Open QR Code File...'}" [buttonClass]="ngClassForButtons" [allowUpload]="true"
        (error)="onError($event)">

      </qr-scanner>


      <div *ngIf="isContainerVisible" class="rectangle-overlay">
        <div class="line" [style.top.%]="linePosition"></div>
      </div>
    </div>
  </div>

  <div class="whitebackground mt-1 mb-1">
    <!-- <div>
                <input type="text" placeholder="Enter OrderId/Mobile number" class="w-100" [(ngModel)]="qrCodeResult"/>
            </div> -->

    <div *ngIf="qrCodeResult && qrCodeResult!=''">
      <div class="full-container" *ngIf="orderDetails?.orderStatus!='Delivered' &&
               orderDetails?.orderStatus!='Completed';else compBlock">
        <div class="container d-flex" style="gap: 1rem;">

          <div class="column">
            <div class="heading font-weight-bold">Order Id:</div>
            <div class="heading font-weight-bold">Order Date:</div>
            <div class="heading font-weight-bold">Order Status:</div>
            <div class="heading font-weight-bold">Total Amount:</div>
            <div class="heading font-weight-bold">Total Items</div>

            <div class="heading font-weight-bold">Payment:</div>
            <div class="heading font-weight-bold">Mode of Payment:</div>

            <!-- <div class="heading">Delivery Address:</div> -->
            <!-- Add more headings as needed -->
          </div>
          <div class="column">
            <div class="value">{{ orderDetails?.orderId }}</div>
            <div class="value">{{ orderDetails?.orderDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</div>
            <div class="vallue">{{orderDetails?.orderStatus}}</div>
            <div class="value">{{ orderDetails?.amount }}</div>
            <div class="value">{{orderDetails?.orderItemCount}}</div>
            <div class="value">{{ orderDetails?.paymentStatus }}</div>
            <div class="value">{{ orderDetails?.paymentMode}}</div>

            <!-- <div class="value">{{ orderDetails?.shippingAddressName }}</div> -->
            <!-- Add more values as needed -->
          </div>
        </div>

        <div class=" mt-3 ml-3 mb-3">
          <div class="row font-bold mb-1">
            <!-- Headings -->
            <div class="col"><strong>Item ID/Name</strong></div>
            <div class="col text-center"><strong> Qty </strong></div>
            <div class="col"><strong> Price</strong></div>
          </div>
          <div *ngFor="let orderitems of orderDetails.orderItems" class="row clearfix mb-2">
            <!-- Values -->
            <div class="col">{{ orderitems?.itemName }}-{{
              orderitems?.uom}}</div>
            <div class="col text-center"> {{ orderitems.quantity }}</div>
            <div class="col">{{ orderitems.totalPrice }}</div>
          </div>
        </div>
        <div class="d-flex justify-content-between p-2">
          <button class="btn btn-danger cancel" (click)="OnClose()">Cancel</button>
          <button class="btn btn-primary dispense">Dispense</button>
        </div>
      </div>

    </div>
    <ng-template #compBlock>
      <div class="d-flex justify-content-center">
        <span>
          Order Status: {{orderDetails?.orderStatus}}
        </span>
        <p class="text-danger font-weight-bold" *ngIf="qrCodeResult">Only order status with InProcess or Submitted will
          be shown</p>
      </div>

    </ng-template>

  </div>
</ng-template>